<template>
  <section class="offer">
    <div class="container offer__container">
      <div class="offer__info">
        <h2>улучшим любое предложение</h2>
        <p>Гарантируем отличные условия покупки!</p>
        <span>Оставьте заявку и узнайте свою выгоду.</span>
      </div>

      <div class="offer__form">
        <callback-input :horizontal="true" :data="{ type: 'sale', form: 'offer' }" v-on="$listeners">
          заказать звонок
        </callback-input>
      </div>

      <div class="offer__form--tablet">
        <callback-input :data="{ type: 'sale', form: 'offer' }" v-on="$listeners">
          заказать звонок
        </callback-input>
      </div>
    </div>
  </section>
</template>

<script>
import callbackInput from './callback-form/index.vue';

export default {
  name: 'offer-block',
  components: {callbackInput},
	data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>

.offer {
  padding: 74px 0;
  background: #F1F5F7;
  &__container {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
  }
  &__info {
    h2 {
      font-size: 30px;
      text-transform: uppercase;
    }
    p {
      font-size: 20px;
      margin: 23px 0 8px;
    }
    span {
      font-size: 20px;
      font-weight: 300;
    }
  }
  &__form {
    &--tablet {
      display: none;
    }
  }
}

@media (max-width: 880px) {
  .offer {
    &__form {
      display: none;
      &--tablet {
        display: block;
      }
    }
    &__container {
      grid-template-columns: 3fr 2fr;
      column-gap: 60px;
    }
    &__info {
      h2 {
        font-size: 28px;
      }
      p {
        font-size: 18px;
      }
      span {
        font-size: 18px;
      }
    }
  }
}

@media (max-width: 640px) {
  .offer {
    padding: 45px 0;
    &__container {
      grid-template-columns: 1fr;
      row-gap: 25px;
    }
    &__info {
      h2 {
        font-size: 24px;
      }
      p {
        font-size: 16px;
      }
      span {
        font-size: 16px;
      }
    }
  }
}

</style>
